import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import FJMobileTextToImageEditFooter from './FJMobileTextToImageEditFooter';
import { setMobileFooterModalData } from '../../../redux/slices/FJSliceModals';

const FJMobileTextToImageEditFooterContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const curStyle = useSelector(state => state.textToImage.curStyle);
    const curModel = useSelector(state => state.textToImage.curModel);
    const curRatio = useSelector(state => state.textToImage.curRatio);
    const generateNumber = useSelector(state => state.textToImage.generateNumber);

    const showFooterModal = data => {
        dispatch(setMobileFooterModalData({ ...data, display: true }));
    };
    return (
        <FJMobileTextToImageEditFooter
            curModel={curModel}
            curStyle={curStyle}
            curRatio={curRatio}
            generateNumber={generateNumber}
            showFooterModal={showFooterModal}
        />
    );
};
export default FJMobileTextToImageEditFooterContainer;
